import { SliderAttributeProps } from 'Types/Attribute.types'
import { Flex, Slider } from 'antd/lib'
import React, { useCallback, useEffect, useMemo } from 'react'
import './Slider.less'

const SliderAttribute: React.FC<SliderAttributeProps> = props => {
    const handleChange = useCallback(
        (newValue: number) => {
            props.onChange(newValue)
        },
        [props]
    )

    const valueLabel = useMemo(() => {
        if (props.value !== undefined && props.value >= props.min && props.value <= props.max) {
            return `${props.value}`
        }
        return '*'
    }, [props.max, props.min, props.value])

    useEffect(() => {
        if (props.value === undefined || props.value < props.min || props.value > props.max) {
            props.onChange(props.min)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.onChange, props.max, props.min])

    return (
        <div
            className={`slider-attribute ${props.className}`}
            style={{ width: props.width ?? '90%' }}
            data-testid="slider-wrapper"
        >
            {!props.readonly ? (
                <div>
                    <div className="slider-attribute-title slider-attribute-editable">
                        <span>{props.label}</span>
                        <span>{`${valueLabel}/${props.max}`}</span>
                    </div>
                    <Slider
                        min={props.min}
                        max={props.max}
                        step={props.step}
                        onChange={handleChange}
                        value={props.value}
                        tooltip={{ open: false }}
                        disabled={props.readonly}
                    />
                </div>
            ) : (
                <Flex vertical className="slider-attribute-title">
                    <span>{props.label}</span>
                    <span className="slider-attribute-non-editable">{`${valueLabel}/${props.max}`}</span>
                </Flex>
            )}
        </div>
    )
}

export default SliderAttribute
